import {
	AddOn,
	AddOnPlan,
	AddOnStatus,
	AddOnType,
	Asset,
	BillingCycle,
	Currency,
	HighlightFeature,
	Price,
	UsageStats,
	UsageStatsType,
} from "../../../../index";
import plutioProvider from "../../providers/prod/plutio";

const a011AddOn = new AddOn({
	internalId: "a011",
	externalId: "pro_stage_a011_plutio_enhancements",
	shortName: "Enhancements",
	longName: "Plutio Enhancements",
	shortDescription: "Tabs and link chips bundled for advanced Plutio surfaces.",
	longDescription:
		"Bundle the Plutio Tabs and Link Chips packages to inject custom tabbed workflows and styled link chips into Plutio without stitching together multiple libraries.",
	type: AddOnType.SERVICE,
	iconAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/a009/icons/a009_icon_rounded.png"
	),
	coverAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/background1.png"
	),
	previewAssets: [
		Asset.image(
			"https://storage.googleapis.com/cdn.version2.io/add-ons/a009/screenshots/a009_screenshot_1.png"
		),
		Asset.image(
			"https://storage.googleapis.com/cdn.version2.io/add-ons/a009/screenshots/a009_screenshot_2.png"
		),
	],
	docsUrl: "https://docs.version2.io/articles/assets-generator-bae920-829dc",
	providersIds: [plutioProvider._.id],
	status: AddOnStatus.IN_REVIEW,
		plans: [
			new AddOnPlan({
				billingCycle: BillingCycle.yearly(),
				internalId: "a011_p001",
				externalId: "pri_stage_a011_yearly",
				prices: [new Price({ currency: Currency.USD, amount: 0 })],
			}),
			new AddOnPlan({
				billingCycle: BillingCycle.monthly(),
				internalId: "a011_p002",
				externalId: "pri_stage_a011_monthly",
				prices: [new Price({ currency: Currency.USD, amount: 0 })],
			}),
		],
	usageStats: [
		new UsageStats({
			id: "custom_tabs",
			name: "Custom tabs",
			description: "Number of custom tab collections injected into Plutio workspaces.",
			type: UsageStatsType.DOCUMENTS,
			max: 50,
		}),
		new UsageStats({
			id: "link_chips",
			name: "Link chips rendered",
			description: "Total link chips rendered inside Plutio automations each month.",
			type: UsageStatsType.REQUESTS,
		}),
	],
	settingsConfig: [],
	highlightFeatures: [
		new HighlightFeature({
			title: "Custom tabs",
			description: "Create and manage tabbed workflows that feel native inside Plutio.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/layout.svg",
		}),
		new HighlightFeature({
			title: "Link chips",
			description: "Convert URLs into compact, clickable chips with platform metadata.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/filter.svg",
		}),
		new HighlightFeature({
			title: "Framework ready",
			description: "React and Vue friendly entry points with full styling control.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/eye.svg",
		}),
	],
});

export default a011AddOn;
